enum CalendarView {
  Week = 'week',
  Month = 'month',
}

export default CalendarView;
